// layouts
import DefaultLayout from "./layouts/DefaultLayout";
// views
import Views from "./modules";

const routes = [
    {
        path: "/projects",
        layout: DefaultLayout,
        exact: true,
        component: Views.ProjectsView,
    },
    {
        path: "/blog",
        layout: DefaultLayout,
        exact: true,
        component: Views.BlogView,
    },
    {
        path: "/resume",
        layout: DefaultLayout,
        exact: true,
        component: Views.ResumeView,
    },
    {
        path: "/",
        layout: DefaultLayout,
        exact: true,
        component: Views.HomeView,
    },
    {
        path: "/services",
        layout: DefaultLayout,
        exact: true,
        component: Views.ServicesView,
    },
];

export default routes;
